import { ArrowDown, ArrowUp, Minus } from 'lucide-react';

interface Props {
  rank: number | null;
  delta: number | null;
}

export function RankDelta({ rank, delta }: Props) {
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-chariot-text-primary font-semibold">{rank}</span>
      {delta !== null && delta > 0 && (
        <span className="flex items-center gap-0.5 text-xs text-green-500">
          <ArrowUp className="size-3" />
          {delta}
        </span>
      )}
      {delta !== null && delta < 0 && (
        <span className="flex items-center gap-0.5 text-xs text-red-500">
          <ArrowDown className="size-3" />
          {Math.abs(delta)}
        </span>
      )}
      {delta !== null && delta === 0 && (
        <Minus className="size-3 text-amber-500" />
      )}
    </div>
  );
}
